import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "p-mb-0" }, "Activité et revenue par abonnment actuel", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.revenueBySubscription,
    class: "p-datatable-gridlines",
    rows: _ctx.revenueBySubscription.length,
    dataKey: "subscriptionId",
    rowHover: false,
    responsiveLayout: "scroll",
    loading: _ctx.loading
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    empty: _withCtx(() => [
      _createTextVNode(" Aucun abonnment disponible actuellement ")
    ]),
    loading: _withCtx(() => [
      _createTextVNode(" Chargement des données ... ")
    ]),
    footer: _withCtx(() => [
      _createTextVNode(" TOTAL : " + _toDisplayString(_ctx.revenueBySubscription.reduce((sum, cur) => sum + cur.amountSum, 0)), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "subscriptionId",
        header: "Type d'abonnement"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(_ctx.$tm(`home.subscriptions`)[data.subscriptionId]), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        field: "activityCount",
        header: "Nombre d'activités abonnées"
      }),
      _createVNode(_component_Column, {
        field: "amountSum",
        header: "Chiffres d'affaires"
      })
    ]),
    _: 1
  }, 8, ["value", "rows", "loading"]))
}